<template lang="pug">
  include ./../../mixins
  +b.cabinet-modal
    +b.bg--white.pa--f_sm.--f_md-md.--f_lg-lg
      +b.ma--b_md.TEXT-BEMTO(
        :cfg="'center'"
        :fw="'bold'"
        :lh="'small'"
        :fs="'xl'"
        :color="'black'"
        :tag="'p'"
      ) {{ title }}
      +b.cabinet-modal__timer.TEXT-BEMTO(
        :cfg="'center'"
        :fw="'bold'"
        :lh="'small'"
        :fs="'xl'"
        :color="'black'"
        :tag="'p'"
      ) {{ currentTime }}
</template>

<script>
export default {
  name: 'RedirectModal',
  props: {
    /**
     * An should be shown text, but the backend did not send a message.
     * Backend forgot send text, but I need to say something.
     */
    objectItem: {},
  },
  /**
   * As soon as the component is
   * installed, we start the
   * counter.
   */
  mounted() {
    this.startTimer()
  },
  /**
   * As soon as the component
   * ends its life, we start
   * the stop.
   */
  destroyed() {
    this.stopTimer()
  },
  data() {
    return {
      /**
       * Component state.
       */
      currentTime: 5,
      timer: null,
      delay: 1000,
    }
  },
  watch: {
    /**
     * Reached zero, url redirect.
     */
    currentTime(time) {
      const start = 0
      if (time === start) {
        this.stopTimer()
        /**
         * Data transfer to redirect.
         */
        this.redirect(
          this.objectItem.url
        )
      }
    }
  },
  computed: {
    /**
     * Handlers that affect the display
     * of the component.
     */
    title() {
      return this.objectItem.title
    },
  },
  methods: {
    /**
     * Timer start event handler.
     */
    startTimer() {
      this.timer = setInterval(() => {
        this.currentTime--
      }, this.delay)
    },
    /**
     * Timer stop event handler.
     */
    stopTimer() {
      clearTimeout(this.timer)
    },
    /**
     * If there is where to redirect,
     * then we will do it.
     */
    redirect(URL) {
      window.location = URL
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/Modals/RedirectModal.vue